module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "headerholder",
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 fullHeight",
    attrs: {
      "items": _vm.soColumns,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          staticClass: "px-1",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.checked),
            callback: function($$v) {
              _vm.$set(props.item, "checked", $$v)
            },
            expression: "props.item.checked"
          }
        })], 1), _vm._v(" "), (!_vm.fncCheckNumber(props.item.id)) ? _c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.label))]) : _vm._e(), _vm._v(" "), (_vm.fncCheckNumber(props.item.id)) ? _c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_c('v-select', {
          staticStyle: {
            "width": "87%",
            "display": "block",
            "float": "left",
            "margin-top": "0px !important"
          },
          attrs: {
            "label": "Select Column Role",
            "item-value": "id",
            "items": _vm.vendorRoles,
            "item-text": "name",
            "solo": "",
            "outline": "",
            "autocomplete": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSetId(props.item)
            }
          },
          model: {
            value: (props.item.id),
            callback: function($$v) {
              _vm.$set(props.item, "id", $$v)
            },
            expression: "props.item.id"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "40%"
          }
        }, [_c('v-select', {
          attrs: {
            "item-value": "id",
            "items": _vm.columnWidths,
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.width),
            callback: function($$v) {
              _vm.$set(props.item, "width", $$v)
            },
            expression: "props.item.width"
          }
        })], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveSettings.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)])], 1)], 1)
},staticRenderFns: []}